<div class="d-flex justify-content-between">
    <h2 mat-dialog-title class="bg-white text-center ps-4">
        {{'contact_us.modal.title' | translate}}
    </h2>
    <mat-dialog-actions>
        <button type="button" class="btn p-0 border-0 fs-4 text-secondary" (click)="onClose()"><i
                class="fa-regular fa-xmark"></i></button>
    </mat-dialog-actions>
</div>
<mat-dialog-content class="dialog-content-pad-15 pb-1 pt-0">   
    <p class="text-secondary fst-italic pb-2">{{'contact_us.modal.content' | translate:{email: dialogData.user.email} }}</p>

    <form [formGroup]="messageFormGroup" class="form pt-1">
        <div class="form-group">
            <label class="form-label fw-bold" for="message">{{'contact_us.modal.messageLabel' | translate}}</label>
            <textarea class="form-control pt-2" id="message" rows="7"
                        [formControl]='messageCtrl'
                        [placeholder]="'contact_us.modal.messagePlaceholder' | translate" required></textarea>
        </div>
        <p class="error-message text-secondary ps-1">
            @if(messageFormGroup.invalid){ {{'contact_us.modal.messageInfo' | translate}} }
        </p>
    </form>
</mat-dialog-content>

<mat-dialog-actions>
    <button type="button"
            class="btn btn-primary mb-1"
            [disabled]="messageFormGroup.invalid"
            (click)="sendMessage()">{{'contact_us.modal.send' | translate }}&nbsp;<i class="far fa-paper-plane-top ps-1"></i></button>
</mat-dialog-actions>